var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"animated-text",class:{'active': _vm.started && !_vm.stopped},domProps:{"textContent":_vm._s(_vm.visibleText)}})])}
var staticRenderFns = []

export { render, staticRenderFns }